module.exports = __webpack_public_path__ + "img/logo-full-white.b4733f74.svg";